import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=45beb5e9&lang=scss"
import "./App.vue?vue&type=style&index=1&id=45beb5e9&lang=scss"

const __exports__ = script;

export default __exports__